import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default () => {
	const headerClass = 'hd-Header';
	const header = document.querySelector(`.${headerClass}`);
	const body = document.body;
	let isVisible = 1;
	let direction = -1;
	let isProduct = false;
	let isProductPassed = false;
	let searchIsOpen = false;
	let product = document.querySelector('.product');
	const account = document.querySelector('.account, .cart');

	document.addEventListener('mobile-search-state', (evt) => {
		searchIsOpen = evt.detail.open;
	});

	body.classList.add('is-header-visible');

	if (product) {
		isProduct = true;
		body.classList.add('template-product');
	}
	else {
		body.classList.remove('template-product');
	}
	if (account) {
		header.classList.add('header--dark-mobile');
	}
	else {
		header.classList.remove('header--dark-mobile');
	}

	if (isProduct) {
		const productMain = document.querySelector('.product__main');
		let mainHeight = productMain.offsetHeight;

		let stProduct = ScrollTrigger.create({
			trigger: product,
			start: 'top 1px',
			end: `bottom-=${mainHeight} top`,

			onEnterBack: () => {
				setHeader(1);
				isProductPassed = false;
			},
			onLeave: () => {
				setHeader(0);
				isProductPassed = true;
			}

		});

		let st = ScrollTrigger.create({
			trigger: document.body,
			start: 'top 1px',
			end: 'bottom bottom',
			scrub: true,
			onUpdate: (self) => {
				direction = self.direction;
				if (isProductPassed && direction == 1 && isVisible == 1) {
					setHeader(0);
				}

				if (isProductPassed && direction == -1 && isVisible == 0) {
					setHeader(1);
				}
			}
		});

	}
	else {
		let st = ScrollTrigger.create({
			trigger: document.body,
			start: 'top 1px',
			end: 'bottom bottom',
			scrub: true,
			onUpdate: (self) => {
				let progress = self.progress;

				direction = self.direction;

				if (progress < 0.03) {
					if (isVisible == 0) {
						setHeader(1);
					}
				}
				else {
					if (direction === 1 && isVisible === 1) {
						setHeader(0);
					}
					if (direction === -1 && isVisible === 0) {
						setHeader(1);
					}
				}
			}
		});
	}

	function setHeader(state) {
		if (searchIsOpen) return;

		if (state) {
			header.classList.remove(`${headerClass}--hidden`);
			body.classList.remove('is-header-hidden');
			body.classList.add('is-header-visible');
			isVisible = 1;
		} else {
			header.classList.add(`${headerClass}--hidden`);
			body.classList.add('is-header-hidden');
			body.classList.remove('is-header-visible');
			isVisible = 0;
		}
	}
};
